import { QuestionsType, UserInputType } from 'src/viewLayer/components/nodes/types.common';

// returns the user response to a specific question from the app state
// uses local storage as a backup if there is nothing in the app state
export const getUserResponseToQuestion = (
  userInput: Partial<UserInputType>,
  requiredQuestionName: string
): string | undefined => {
  const questionName = `question_${ requiredQuestionName }` as keyof QuestionsType;
  let userResponse;
  userResponse = userInput?.questions?.[questionName];

  if (!userResponse) {
    const userInputFromLocalStorage = JSON.parse(localStorage.getItem('userInput')) as Partial<UserInputType>;
    userResponse = userInputFromLocalStorage?.questions?.[questionName];
  }

  return userResponse;
};
